// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerobatic-manoeuvre-rules.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerobatic-manoeuvre-rules/aerobatic-manoeuvre-rules.js';
import g1 from '../lessons/air-law/aerobatic-manoeuvre-rules/aerobatic-passenger-currency.js';

mount([g0, g1]);
